import { useOutletContext } from 'react-router-dom';

import { Company } from '@/services/hsm-backend';

export interface CompanyContext {
  company: Company;
  refetch: () => Promise<void>;
}

/**
 * Typed accessor for the `CompanyShell`'s outlet context. Children mounted
 * under the `/company/:companyId/*` routes call this to get the loaded
 * company and a `refetch` handle (useful after a successful POST that
 * changes billing state).
 */
export const useCompanyContext = (): CompanyContext =>
  useOutletContext<CompanyContext>();
